/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import AutocompleteFloatLabel from "../../../components/AutocompleteFloatLabel";
import DialogMessage from "../../../components/DialogMessage";
import DialogMessageProps from "../../../model/DialogMessageProps";
import Cartao from "../../../model/dto/Cartao";
import Justificativa from "../../../model/dto/Justificativa";
import { TipoCartaoEnum } from "../../../model/Enums/TipoCartaoEnum";
import { TypeDialogMessageEnum } from "../../../model/Enums/TypeDialogMessageEnum";
import CartaoParams from "../../../model/params/CartaoParams";
import SelectOption from "../../../model/SelectOption";
import CartoesService from "../../../service/Docente/CartoesService";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import GenericUtils from "../../../utils/GenericUtils";
import Modalidade from "../../../model/dto/Modalidade";

const { BtnPrimary } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

export default function ContentAntecipacao(props: any) {
    const { instance } = useMsal();

    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);

    const [activity, setActivity] = useState(new Array<SelectOption>());
    const [activityOptions, setActivityOptions] = useState(
        new Array<SelectOption>()
    );

    const isFormValid = !!activity.length;

    const getModalityId = (
        cartaoTipoId: number,
        modalidade: Modalidade | null = null
    ) => {
        if (
            modalidade &&
            (cartaoTipoId === TipoCartaoEnum.HoraLetiva ||
                cartaoTipoId === TipoCartaoEnum.HoraNaoLetivaFlutuante)
        )
            return modalidade.modalidadeId;

        return null;
    };

    const getCartoes = async () => {
        const modalidadeId = getModalityId(
            props?.props?.detail?.cartaoTipo?.cartaoTipoId,
            props?.props?.detail?.modalidade
        );

        let cartaoParams = GenericUtils.impl<CartaoParams>({
            justificativaAntecipacao: true,
            tipoCartaoId: [TipoCartaoEnum.Antecipacao],
            docenteId: props?.props?.detail?.docenteId,
            centroResultadoId:
                props?.props?.detail?.abrangencia?.centroResultadoId,
            duracaoHoraAula: props?.props?.detail?.duracaoHoraAula,
            titulo: props?.props?.detail?.tituloCartao,
        });

        if (modalidadeId) {
            cartaoParams = GenericUtils.impl<CartaoParams>({
                ...cartaoParams,
                modalidadeId,
            });
        }

        const response = await CartoesService.getCartoes(
            instance,
            cartaoParams
        );
        // item.cartaoAgendaId !== props?.props?.detail?.cartaoAgendaId &&
        if (GenericUtils.isSuccessStatus(response)) {
            let cartoes: SelectOption[] = [];

            response.data?.cartoes?.forEach((item: Cartao) => {
                const modalidadeDescricao =
                    item.modalidade && item.modalidade.modalidadeDescricao
                        ? ` - ${item.modalidade.modalidadeDescricao}`
                        : "";

                cartoes.push({
                    value: item?.cartaoAgendaId,
                    label: item?.titulo,
                    labelSecondary: `${item.abrangencia?.nome}${modalidadeDescricao}`,
                } as SelectOption);
            });
            cartoes = cartoes.filter(
                (item) =>
                    item.value !==
                    props?.props?.detail?.cartaoAgendaId.toString()
            );
            setActivityOptions(cartoes);
        } else {
            setActivityOptions([]);
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const handleSubmit = async () => {
        if (!isFormValid) return;

        const dto = GenericUtils.impl<Justificativa>({
            tipoJustificativa: "ANTECIPACAO",
            cartaoVinculo: Number(activity[0]?.value),
        });

        const response = await CartoesService.justificativaCartao(
            instance,
            props?.props?.detail?.cartaoAgendaId,
            dto
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "Justificativa realizada",
            });
        } else {
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const handleCloseDialogMessage = () => {
        if (dialogMessageProps.type === TypeDialogMessageEnum.Success) {
            props?.props?.refreshScheduleCard([
                props?.props?.detail?.cartaoAgendaId,
                Number(activity[0]?.value),
            ]);
            props?.props?.onClose();
        }
        setDialogMessageProps({} as DialogMessageProps);
    };

    useEffect(() => {
        getCartoes();
    }, []);

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={handleCloseDialogMessage}
        />
    );

    return (
        <>
            <Row className="mt-4">
                <Col>
                    <AutocompleteFloatLabel
                        placeholder="Selecione a atividade antecipada"
                        options={activityOptions}
                        selected={activity}
                        onChange={setActivity}
                        typeForm="default"
                        labelSecondary
                    />
                </Col>
            </Row>
            <StyledContainerButton>
                <BtnPrimary disabled={!isFormValid} onClick={handleSubmit}>
                    Confirmar
                </BtnPrimary>
            </StyledContainerButton>
            {dialogMessage}
        </>
    );
}
